import { getTronRentResourceRecordExport } from "src/api/tronRentResourceRecords";
import { Box, Container } from "src/components/MuiGenerals";
import TableTab from "src/components/TableTab";
import PageConfigProvider, {
  usePageConfigProviderContext,
} from "src/features/PageConfigProvider";
import { FeatureCodes } from "src/utils/constant";
import { DivideLine } from "src/utils/HelperComp";
import { customSx } from "src/utils/styling";
import { exportButtonOmitKeys } from "./constants/exportButtonOmitKeys";
import useRenderFilters from "./helpers/useRenderFilters";
import useTableColumns from "./helpers/useTableColumns";
import useTableRows from "./helpers/useTableRows";
import { GetListRes } from "./types/GetListRes";

const ExportPermission =
  FeatureCodes.assetManagement.TronRentResourceRecords.Export;

const ViewFilterTable = () => {
  const { list } = usePageConfigProviderContext<unknown, GetListRes>();

  const { renderFields } = useRenderFilters();
  const { columns } = useTableColumns();
  const { rows, mapResultToTupleArray } = useTableRows({ apiList: list });

  return (
    <Box sx={customSx.layoutBox}>
      <Box sx={customSx.filterCmdBar}>
        <PageConfigProvider.ExportButton
          fileName="Tron Rent Resource Batch Wallets"
          permissionKey={ExportPermission}
          mapResultToTupleArray={mapResultToTupleArray}
          exportTableApiFunc={getTronRentResourceRecordExport}
          omitKeys={exportButtonOmitKeys}
        />
      </Box>
      <Container disableGutters maxWidth={false}>
        <Box sx={customSx.gridFilter} className="gridFilter">
          {renderFields()}
        </Box>
        <PageConfigProvider.SearchAndResetBox />
      </Container>
      <DivideLine />
      <Container
        style={customSx.datagridContainer}
        maxWidth={false}
        disableGutters
      >
        <TableTab>
          <PageConfigProvider.DataGrid columns={columns} rows={rows} />
        </TableTab>
      </Container>
    </Box>
  );
};

export default ViewFilterTable;
